export default {
  CLIENT_ERROR: 'requestError', // 400, 401, 404, 409, 410, 429
  SERVER_ERROR: 'notRequestError', // 500, 503
  TIMEOUT_ERROR: 'notRequestError',
  NETWORK_ERROR: 'notRequestError',
  CONNECTION_ERROR: 'notRequestError'
}
